// app/javascript/controllers/dialog_controller.js
import Dialog from '@stimulus-components/dialog'

export default class extends Dialog {
    open(event) {
        // Save current scroll position
        this.scrollY = window.scrollY

        // Fix body and maintain scroll position visually
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this.scrollY}px`
        document.body.style.width = '100%'

        super.open(event)
    }

    close(event) {
        // Let parent handle animation
        super.close(event)

        // After dialog closes, restore body scroll
        this.dialogTarget.addEventListener('close', () => {
            const scrollY = this.scrollY

            // Remove fixed positioning
            document.body.style.position = ''
            document.body.style.top = ''
            document.body.style.width = ''

            // Restore scroll position
            window.scrollTo(0, scrollY)
        }, { once: true })
    }
}